<template lang="pug">
  .team-task-form
    div.columns(v-if="value.type!=='backlog'")
      div.column
        b-field(label="Статус*", :type="errors && errors.status ? 'is-danger' : ''", :message="errors.status")
          b-select(v-model="value.team_status")
            option(v-for="(status, key) in value.teamStatuses" :value="key" :key="key")
              | {{ status.name }}
      div.column
        b-field(label="Исполнитель*", :type="errors && errors.executor_id ? 'is-danger' : ''", :message="errors.executor_id")
          b-select(v-model="value.executor_id")
            option(v-for="(name, key) in value.executors" :value="key" :key="key")
              | {{ name }}

    b-field(label="Дедлайн", :type="errors && errors.deadline_at ? 'is-danger' : ''", :message="errors.deadline_at")
      b-input(v-model="value.deadline_at", type="date")

    b-field(label="Заголовок задачи*", :type="errors && errors.title ? 'is-danger' : ''", :message="errors.title", class="mb-0")
      b-input(v-model="value.title", maxlength="250", type="textarea", rows="2")

    b-field(label="Описание задачи", :type="errors && errors.body ? 'is-danger' : ''", :message="errors.body")
      b-input(v-model="value.body", type="textarea", rows="8")

    b-field.grouped
      ui-upload(v-model="value.files", listStyle="is-light", multiple, simple, wide)
</template>

<script>
import BSelect from 'buefy/src/components/select/Select';

export default {
  name: 'team-task-form',
  components: { BSelect },
  props: {
    value: Object,
    errors: Object,
  },
};
</script>

<style scoped></style>
